import React, { useEffect, useState } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import TurnedInIcon from "@material-ui/icons/TurnedIn";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import { NavLink } from "react-router-dom";
import { Grid, Box, Collapse } from "@material-ui/core";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import _ from "lodash";

import { hasRole, hasRoleDOA, isAllowed } from "src/utils/Auth";
import { useSelector } from "react-redux";

const drawerWidth = 300;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
  isActive: {
    backgroundColor: "#e0f5fd",
    color: "#0080ff",
  },
}));

export default function Menu({
  openDrawer,
  handleDrawerClose,
  userInfo,
  userPermission,
}) {
  const classes = useStyles();
  const theme = useTheme();
  const [openCollapseSetting, setOpenCollapseSetting] = useState(false);
  const [openCollapsePurchaseRequisition, setOpenCollapsePurchaseRequisition] =
    useState(true);

  const [openCollapseBudget, setOpenCollapseBudget] = useState(false);

  const [openCollapseReport, setOpenCollapseReport] = useState(false);

  const handleOpenReports = () => {
    setOpenCollapseReport(!openCollapseReport);
    setOpenCollapseSetting(false);
    setOpenCollapseBudget(false);
    setOpenCollapsePurchaseRequisition(false);
  };

  const handleOpenSettings = () => {
    setOpenCollapseSetting(!openCollapseSetting);
    setOpenCollapseReport(false);
    setOpenCollapseBudget(false);
    setOpenCollapsePurchaseRequisition(false);
  };

  const handleOpenBudget = () => {
    setOpenCollapseBudget(!openCollapseBudget);
    setOpenCollapseSetting(false);
    setOpenCollapseReport(false);
    setOpenCollapsePurchaseRequisition(false);
  };

  const handleOpenCollapsePurchaseRequisition = () => {
    setOpenCollapsePurchaseRequisition(!openCollapsePurchaseRequisition);
    setOpenCollapseBudget(false);
    setOpenCollapseSetting(false);
    setOpenCollapseReport(false);
  };

  const { isLoading } = useSelector((state) => state.loginReducer);

  const { menu, permissionBudget, authorizePR } = useSelector(
    (state) => state.authorizationReducer
  );

  useEffect(() => {
    return () => {};
  }, []);

  const renderListItem = () => {
    if (isLoading) {
      return (
        <ListItem button component={NavLink}>
          <ListItemIcon>
            <InboxIcon />
          </ListItemIcon>
          <ListItemText primary={"Loading..."} />
        </ListItem>
      );
    }

    let item = [];

    let mapMenu = _.chain(menu.data)
      .groupBy("MENU_MODULE")
      .map(function (v, i) {
        return {
          menu: i,
          subItem: v,
        };
      })
      .value();

    mapMenu.map(({ menu, subItem, ...rest }) => {
      item.push(
        <>
          {subItem && (
            <ListItem
              style={{ paddingLeft: 18 }}
              button
              {...rest}
              key={menu}
              onClick={handleOpenBudget}
            >
              <ListItemText>{menu}</ListItemText>
              {openCollapseBudget ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
          )}
          <Collapse in={openCollapseBudget} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {subItem.map(({ MENU_DISPLAY, ROUTE, SECURITIES }) => {
                return (
                  hasRole(permissionBudget.data, SECURITIES) && (
                    <ListItem
                      key={MENU_DISPLAY}
                      button
                      component={NavLink}
                      activeClassName={classes.isActive}
                      to={ROUTE}
                    >
                      <TurnedInIcon />
                      <ListItemText
                        style={{ marginLeft: 10 }}
                        className="sidebar-item-text"
                      >
                        {MENU_DISPLAY}
                      </ListItemText>
                    </ListItem>
                  )
                );
              })}
            </List>
          </Collapse>
        </>
      );
    });

    return item;
  };

  return (
    <div>
      <Drawer
        variant="persistent"
        anchor="left"
        open={openDrawer}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.drawerHeader}>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "ltr" ? (
              <ChevronLeftIcon />
            ) : (
              <ChevronRightIcon />
            )}
          </IconButton>
        </div>
        <Divider />
        <Grid container>
          <Box severity="success" flex={1} p={2}>
            <img style={{ margin: 0 }} width={80} src={userInfo.country_img} />
            <h4>{userInfo.country}</h4>
            <h4>{userInfo.company}</h4>
            <h4>Currency : {userInfo.currency_code}</h4>
          </Box>
        </Grid>
        <Divider />
        <List>
          {/* <ListItem
            style={{ paddingLeft: 18 }}
            button
            onClick={handleOpenCollapsePurchaseRequisition}
          > */}
            {/* <ListItemText>Purchase Requisition</ListItemText> */}
            {/* {openCollapsePurchaseRequisition ? <ExpandLess /> : <ExpandMore />} */}
          {/* </ListItem> */}
          <Collapse
            in={openCollapsePurchaseRequisition}
            timeout="auto"
            unmountOnExit
          >
            {/* <List component="div" disablePadding>
              <ListItem
                button
                activeClassName={classes.isActive}
                to={`/purchase-requisition-list`}
                component={NavLink}
              >
                <TurnedInIcon />
                <ListItemText
                  style={{ marginLeft: 10 }}
                  className="sidebar-item-text"
                >
                  Purchase Requisition List
                </ListItemText>
              </ListItem>
              {hasRoleDOA(authorizePR.data, [
                "Reviewer",
                "Approver-DoA",
                "Schedule Delegation for Approver",
                "Approver Delegate",
              ]) && (
                <ListItem
                  button
                  activeClassName={classes.isActive}
                  to={`/pr-list-reviewer`}
                  component={NavLink}
                >
                  <TurnedInIcon />
                  <ListItemText
                    style={{ marginLeft: 10 }}
                    className="sidebar-item-text"
                  >
                    PR List (Reviewer)
                  </ListItemText>
                </ListItem>
              )}
              {hasRoleDOA(authorizePR.data, [
                "Approver-DoA",
                "Schedule Delegation for Approver",
                "Approver Delegate",
                "Represent CEO",
              ]) && (
                <ListItem
                  button
                  activeClassName={classes.isActive}
                  to={`/pr-list-approver`}
                  component={NavLink}
                >
                  <TurnedInIcon />
                  <ListItemText
                    style={{ marginLeft: 10 }}
                    className="sidebar-item-text"
                  >
                    PR List (Approver)
                  </ListItemText>
                </ListItem>
              )}
              {hasRoleDOA(authorizePR.data, ["Requestor", "Legal"]) && (
                <ListItem
                  button
                  activeClassName={classes.isActive}
                  to={`/search-contact`}
                  component={NavLink}
                >
                  <TurnedInIcon />
                  <ListItemText
                    style={{ marginLeft: 10 }}
                    className="sidebar-item-text"
                  >
                    Contract Search
                  </ListItemText>
                </ListItem>
              )}
              {hasRoleDOA(authorizePR.data, ["Legal"]) && (
                <ListItem
                  button
                  activeClassName={classes.isActive}
                  to={`/condition-contact-search`}
                  component={NavLink}
                >
                  <TurnedInIcon />
                  <ListItemText
                    style={{ marginLeft: 10 }}
                    className="sidebar-item-text"
                  >
                    Condition Contract Search
                  </ListItemText>
                </ListItem>
              )}
              {isAllowed(authorizePR.data, [
                "can_view_purchase_requisition_job",
              ]) && (
                <ListItem
                  button
                  activeClassName={classes.isActive}
                  to={`/purchase-requisition-job`}
                  component={NavLink}
                >
                  <TurnedInIcon />
                  <ListItemText
                    style={{ marginLeft: 10 }}
                    className="sidebar-item-text"
                  >
                    Purchase Requisition Job
                  </ListItemText>
                </ListItem>
              )}
              {isAllowed(authorizePR.data, ["can_view_budget_management"]) && (
                <ListItem
                  button
                  activeClassName={classes.isActive}
                  to={`/budget-management`}
                  component={NavLink}
                >
                  <TurnedInIcon />
                  <ListItemText
                    style={{ marginLeft: 10 }}
                    className="sidebar-item-text"
                  >
                    Budget Management
                  </ListItemText>
                </ListItem>
              )}
              {isAllowed(authorizePR.data, [
                "can_view_budget_adjustment_requisition",
              ]) && (
                <ListItem
                  button
                  activeClassName={classes.isActive}
                  to={`/budget-adjustment-requisition`}
                  component={NavLink}
                >
                  <TurnedInIcon />
                  <ListItemText
                    style={{ marginLeft: 10 }}
                    className="sidebar-item-text"
                  >
                    Budget Adjustment
                  </ListItemText>
                </ListItem>
              )}
              {isAllowed(authorizePR.data, [
                "can_view_review_budget_adjustment_requisition",
              ]) && (
                <ListItem
                  button
                  activeClassName={classes.isActive}
                  to={`/review-budget-adjustment-requisition`}
                  component={NavLink}
                >
                  <TurnedInIcon />
                  <ListItemText
                    style={{ marginLeft: 10 }}
                    className="sidebar-item-text"
                  >
                    Review Budget Adjustment
                  </ListItemText>
                </ListItem>
              )}
              {isAllowed(authorizePR.data, [
                "can_view_verify_budget_adjustment_requisition",
              ]) && (
                <ListItem
                  button
                  activeClassName={classes.isActive}
                  to={`/verify-budget-adjustment-requisition`}
                  component={NavLink}
                >
                  <TurnedInIcon />
                  <ListItemText
                    style={{ marginLeft: 10 }}
                    className="sidebar-item-text"
                  >
                    Verify Budget Adjustment
                  </ListItemText>
                </ListItem>
              )}
            </List> */}
          </Collapse>
          <>{renderListItem()}</>
          {hasRole(authorizePR.data, [
            "manager-report",
            "staff-report",
            "super-admin",
            "manager-purchasing-report",
            "admin",
          ]) && (
            <>
              {/* <ListItem
                style={{ paddingLeft: 18 }}
                button
                onClick={handleOpenReports}
              > */}
                {/* <ListItemText>Report</ListItemText> */}
                {/* {openCollapseReport ? <ExpandLess /> : <ExpandMore />} */}
              {/* </ListItem> */}
              {/* <Collapse in={openCollapseReport} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {isAllowed(authorizePR.data, [
                    "can_view_summary_investment_capex_report",
                  ]) && (
                    <ListItem
                      button
                      activeClassName={classes.isActive}
                      to={`/summary-investment-capax`}
                      component={NavLink}
                    >
                      <TurnedInIcon />
                      <ListItemText
                        style={{ marginLeft: 10 }}
                        className="sidebar-item-text"
                      >
                        Summary Investment (CAPEX) Report
                      </ListItemText>
                    </ListItem>
                  )}
                  {isAllowed(authorizePR.data, [
                    "can_view_summary_investment_detail_capex_report",
                  ]) && (
                    <ListItem
                      button
                      activeClassName={classes.isActive}
                      to={`/summary-investment-detail`}
                      component={NavLink}
                    >
                      <TurnedInIcon />
                      <ListItemText
                        style={{ marginLeft: 10 }}
                        className="sidebar-item-text"
                      >
                        Summary Investment Detail (CAPEX) Report
                      </ListItemText>
                    </ListItem>
                  )}
                  {isAllowed(authorizePR.data, [
                    "can_view_summary_expense_opex_report",
                  ]) && (
                    <ListItem
                      button
                      activeClassName={classes.isActive}
                      to={`/summery-expense-opex`}
                      component={NavLink}
                    >
                      <TurnedInIcon />
                      <ListItemText
                        style={{ marginLeft: 10 }}
                        className="sidebar-item-text"
                      >
                        Summary Expense (OPEX) Report
                      </ListItemText>
                    </ListItem>
                  )}
                  {isAllowed(authorizePR.data, [
                    "can_view_summary_expense_detail_opex_report",
                  ]) && (
                    <ListItem
                      button
                      activeClassName={classes.isActive}
                      to={`/summery-expense-detail`}
                      component={NavLink}
                    >
                      <TurnedInIcon />
                      <ListItemText
                        style={{ marginLeft: 10 }}
                        className="sidebar-item-text"
                      >
                        Summary Expense Detail (OPEX) Report
                      </ListItemText>
                    </ListItem>
                  )}
                  {isAllowed(authorizePR.data, [
                    "can_view_transaction_tracking_report",
                  ]) && (
                    <ListItem
                      button
                      activeClassName={classes.isActive}
                      to={`/transaction-tracking`}
                      component={NavLink}
                    >
                      <TurnedInIcon />
                      <ListItemText
                        style={{ marginLeft: 10 }}
                        className="sidebar-item-text"
                      >
                        Transaction Tracking Report
                      </ListItemText>
                    </ListItem>
                  )}
                  {isAllowed(authorizePR.data, [
                    "can_view_ref_list_report",
                  ]) && (
                    <ListItem
                      button
                      activeClassName={classes.isActive}
                      to={`/ref-list-report`}
                      component={NavLink}
                    >
                      <TurnedInIcon />
                      <ListItemText
                        style={{ marginLeft: 10 }}
                        className="sidebar-item-text"
                      >
                        Ref. List Report
                      </ListItemText>
                    </ListItem>
                  )}
                  {isAllowed(authorizePR.data, [
                    "can_view_purchase_request_report",
                  ]) && (
                    <ListItem
                      button
                      activeClassName={classes.isActive}
                      to={`/purchase-request-report`}
                      component={NavLink}
                    >
                      <TurnedInIcon />
                      <ListItemText
                        style={{ marginLeft: 10 }}
                        className="sidebar-item-text"
                      >
                        Purchase Request Report
                      </ListItemText>
                    </ListItem>
                  )}
                  {isAllowed(authorizePR.data, [
                    "can_view_purchase_requisition_status_report",
                  ]) && (
                    <ListItem
                      button
                      activeClassName={classes.isActive}
                      to={`/pr-status-report`}
                      component={NavLink}
                    >
                      <TurnedInIcon />
                      <ListItemText
                        style={{ marginLeft: 10 }}
                        className="sidebar-item-text"
                      >
                        PR Status Report
                      </ListItemText>
                    </ListItem>
                  )}
                </List> */}
              {/* </Collapse> */}
            </>
          )}
          {hasRole(authorizePR.data, ["admin", "super-admin"]) && (
            <>
              <ListItem
                style={{ paddingLeft: 18 }}
                button
                onClick={handleOpenSettings}
              >
                <ListItemText>Settings</ListItemText>
                {openCollapseSetting ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={openCollapseSetting} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItem
                    button
                    activeClassName={classes.isActive}
                    to={`/user-profile`}
                    component={NavLink}
                  >
                    <TurnedInIcon />
                    <ListItemText
                      style={{ marginLeft: 10 }}
                      className="sidebar-item-text"
                    >
                      User Profile Search
                    </ListItemText>
                  </ListItem>
                  <ListItem
                    button
                    activeClassName={classes.isActive}
                    to={`/user-management-setting`}
                    component={NavLink}
                  >
                    <TurnedInIcon />
                    <ListItemText
                      style={{ marginLeft: 10 }}
                      className="sidebar-item-text"
                    >
                      User Management
                    </ListItemText>
                  </ListItem>
                  {hasRole(authorizePR.data, ["super-admin"]) && (
                    <>
                      <ListItem
                        button
                        activeClassName={classes.isActive}
                        to={`/role-management-setting`}
                        component={NavLink}
                      >
                        <TurnedInIcon />
                        <ListItemText
                          style={{ marginLeft: 10 }}
                          className="sidebar-item-text"
                        >
                          Role Management
                        </ListItemText>
                      </ListItem>
                      <ListItem
                        button
                        activeClassName={classes.isActive}
                        to={`/permission-management-setting`}
                        component={NavLink}
                      >
                        <TurnedInIcon />
                        <ListItemText
                          style={{ marginLeft: 10 }}
                          className="sidebar-item-text"
                        >
                          Permission Management
                        </ListItemText>
                      </ListItem>
                    </>
                  )}
                  {hasRole(authorizePR.data, ["super-admin", "admin"]) && (
                    <ListItem
                      button
                      activeClassName={classes.isActive}
                      to={`/over-period-approver`}
                      component={NavLink}
                    >
                      <TurnedInIcon />
                      <ListItemText
                        style={{ marginLeft: 10 }}
                        className="sidebar-item-text"
                      >
                        Setup Notice over approval period
                      </ListItemText>
                    </ListItem>
                  )}
                </List>
              </Collapse>
            </>
          )}
          {hasRoleDOA(authorizePR.data, [
            "Reviewer",
            "Approver-DoA",
            "Legal",
            "CEO",
            "Represent CEO",
            "Purchasing Staff",
            "Schedule Delegation for Approver",
            "Approver Delegate",
          ]) && (
            <ListItem
              button
              component="a"
              href={`https://doa.jaspal.co.th:8080/?user=${localStorage.getItem(
                "@de_token"
              )}`}
              target="_blank"
            >
              <TurnedInIcon />
              <ListItemText>Decision Engine</ListItemText>
            </ListItem>
          )}
        </List>
        <Divider />
      </Drawer>
    </div>
  );
}
